import { ref } from 'vue'

export function useSearchSSE() {
    const activeStreams = ref({
        albums: null,
        concerts: null,
        festivals: null
    })

    const activeSearchViewStream = ref(null)

    const abortStream = (stream) => {
        if (stream && typeof stream.abort === 'function') {
            stream.abort()
        }
    }

    const startStream = (key, streamFactory) => {
        abortStream(activeStreams.value[key])
        const stream = streamFactory()
        activeStreams.value[key] = stream
        return stream
    }

    const clearStream = (key) => {
        activeStreams.value[key] = null
    }

    const cancelAllStreams = () => {
        Object.keys(activeStreams.value).forEach((key) => {
            abortStream(activeStreams.value[key])
            activeStreams.value[key] = null
        })
    }

    const startSearchViewStream = (streamFactory) => {
        abortStream(activeSearchViewStream.value)
        const stream = streamFactory()
        activeSearchViewStream.value = stream
        return stream
    }

    const clearSearchViewStream = () => {
        activeSearchViewStream.value = null
    }

    const cancelSearchViewStream = () => {
        abortStream(activeSearchViewStream.value)
        activeSearchViewStream.value = null
    }

    return {
        activeStreams,
        activeSearchViewStream,
        startStream,
        clearStream,
        cancelAllStreams,
        startSearchViewStream,
        clearSearchViewStream,
        cancelSearchViewStream
    }
}
